import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const OrganizationDropdown = ({ organization, setOrganization }) => {

  const handleChange = (event) => {
    setOrganization(event.target.value);
  };

  const orgList = process.env.REACT_APP_ORG_LIST ? process.env.REACT_APP_ORG_LIST.split(',') : ['n/a']
  const orgListAlias = process.env.REACT_APP_ORG_LIST_ALIAS ? process.env.REACT_APP_ORG_LIST_ALIAS.split(',') : ['n/a']
  const orgDict = orgList.map((key, index) => {
  return <MenuItem value={key}>{orgListAlias[index]}</MenuItem>;
  });

  return (
    <FormControl 
      fullWidth 
      variant="outlined" 
      style = {{margin: '24px 30px 24px 24px'}}
      sx={{ 
        minWidth: 120, 
        '& .MuiOutlinedInput-root': {
          color: 'white',
          '& fieldset': {
            borderColor: 'white',
            borderRadius: '30px',
          },
          '&:hover fieldset': {
            borderColor: 'white',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'white',
          },
        },
        '& .MuiInputLabel-root': {
          color: 'white',
        },
        '& .MuiSelect-icon': {
          color: 'white',
        },
      }}
    >
      <InputLabel id="dropdown-label">ארגון</InputLabel>
      <Select
        labelId="dropdown-label"
        value={organization}
        onChange={handleChange}
        label="בחר אפשרות"
      >
{orgDict}
      </Select>
    </FormControl>
  );
};

export default OrganizationDropdown;
